import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Constants } from "./constants";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { constructor } from "typescript";

// const httpOptions = {
//   headers: new HttpHeaders({ 'Content-Type': 'application/json' })
// };

@Injectable()
export class AuthenticationService {
  tokePush: any;

  currentMessage = new BehaviorSubject<any>(null);
  notifyMessage = new BehaviorSubject<any>(null);
  constructor(private http: HttpClient) {}

  messageRecieved(payload: any) {
    this.currentMessage.next(payload);
  }
  notifyMessageReceived(data: any) {
    this.notifyMessage.next(data);
  }

  login(username, password) {
    // 'Content-Type': 'application/json'
    const headers = new HttpHeaders({});
    return this.http.post(
      Constants.apiAddress + "/login",
      JSON.stringify({ username, password }),
      { headers: headers }
    );
  }
  logout(auth_token) {
    // 'Content-Type': 'application/json'
    const headers = new HttpHeaders({});
    return this.http.post(
      Constants.apiAddress + "/logout",
      JSON.stringify({ auth_token }),
      { headers: headers }
    );
  }
  pushNotify(auth_token, fcm_token) {
    // 'Content-Type': 'application/json'
    const version_number = 1.0;
    const headers = new HttpHeaders({});
    return this.http.post(
      Constants.apiAddress + "/register_fcm_token",
      JSON.stringify({ auth_token, fcm_token, version_number }),
      { headers: headers }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication.service.ts